import store from "@/utils/store/cookie";

const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  userInfo: null,
  breadListState: [
    {
      name: '首页',
      path: '/'
    }
  ]
};

const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, token, expires_time) {
    state.token = token;
    store.set(LOGIN_KEY, token, expires_time);
  },
  LOGOUT(state) {
    state.token = undefined;
    store.remove(LOGIN_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  breadListStateAdd(state, obj) {
    state.breadListState.push(obj);
  },
  breadListStateRemove(state, num) {
    state.breadListState.splice(num, state.breadListState.length - num);
  },
  breadListMutations(getters, list) {
    getters.breadListState = list;
    sessionStorage.setItem('breadListStorage', list);
  }
};

const actions = {
};

export default {
  state,
  mutations,
  actions
};
